import type { CatOrDog, PetGenderSchema, PetSubTypeSchema, PetTypeSchema, PetValueRangeSchema } from '../types/pet';
import { MAX_PET_VALUE_RANGE } from '../types/pet';

export const CAT_PET_TYPE_ID = '1';
export const DOG_PET_TYPE_ID = '2';

export const petValueRanges: PetValueRangeSchema[] = [
  { maxValue: '49', id: 1 },
  { maxValue: '99', id: 2 },
  { maxValue: '149', id: 3 },
  { maxValue: '199', id: 4 },
  { maxValue: '249', id: 5 },
  { maxValue: '299', id: 6 },
  { maxValue: '349', id: 7 },
  { maxValue: '399', id: 8 },
  { maxValue: '449', id: 9 },
  { maxValue: '499', id: 10 },
  { maxValue: '549', id: 11 },
  { maxValue: '599', id: 12 },
  { maxValue: '649', id: 13 },
  { maxValue: '699', id: 14 },
  { maxValue: '749', id: 15 },
  { maxValue: '799', id: 16 },
  MAX_PET_VALUE_RANGE,
];

export const catType: PetTypeSchema = { value: 'cat', id: CAT_PET_TYPE_ID };
export const dogType: PetTypeSchema = { value: 'dog', id: DOG_PET_TYPE_ID };

export const petTypes: PetTypeSchema[] = [catType, dogType];

export const petTypesByValue: Record<CatOrDog, PetTypeSchema> = {
  cat: catType,
  dog: dogType,
};

export const petGenders: PetGenderSchema[] = [
  { gender: 'male', isFemale: false },
  { gender: 'female', isFemale: true },
];

export const petSubTypes: PetSubTypeSchema[] = [
  { type: 'dog', pedigree: 'pedigree', id: '1' },
  { type: 'dog', pedigree: 'crossed', id: '2' },
  { type: 'dog', pedigree: 'mixed', id: '3' },
  { type: 'cat', pedigree: 'pedigree', id: '4' },
  { type: 'cat', pedigree: 'crossed', id: '5' },
  { type: 'cat', pedigree: 'mixed', id: '6' },
];

export const petTypeValueList = petTypes.map((type) => type.value);
export const petSubTypeValueList = petSubTypes.map((subType) => subType.pedigree);
export const petGenderValueList = petGenders.map((gender) => gender.gender);
